import React from 'react';
import ErrorMessage from 'src/shared/components/error-msg/ErrorMessage';
import SuccessMessage from 'src/shared/components/success-message/SuccessMessage';
import HabitatInsightsSamplesUploadAddSite from './components/habitat-insights-samples-upload/HabitatInsightsSamplesUploadAddSite';
import useAddSiteToPlatform from '../../hooks/useAddSiteToPlatform';

type HabitatInsightsSamplesAddSiteProps = {
    isDisabled?: boolean;
};

export const HabitatInsightsSamplesAddSite = ({ isDisabled = false }: HabitatInsightsSamplesAddSiteProps) => {
    const { formState } = useAddSiteToPlatform();

    const { uploadedFileErrors, uploadedFileContent } = formState;

    return (
        <div className='w-[720px] flex flex-col'>
            <HabitatInsightsSamplesUploadAddSite isDisabled={isDisabled} />
            <div className='mt-[50px]'>
                {uploadedFileContent.length > 0 ? (
                    uploadedFileErrors.length > 0 ? (
                        <ul>
                            {uploadedFileErrors.map((error, index) => (
                                <ErrorMessage key={index} message={<span dangerouslySetInnerHTML={{ __html: error.message }} />} />
                            ))}
                        </ul>
                    ) : (
                        <SuccessMessage message={'Data successfully uploaded with no errors'} />
                    )
                ) : null}
            </div>
        </div>
    );
};

export default HabitatInsightsSamplesAddSite;
